// Card.js
import React from "react";
import "./css/InternCard.css";

const InternCard = ({ title, image }) => {
  return (
    <div className="col-6 d-flex">
      <div className="card h-100 w-100">
        <img src={image} alt={title} className="card-image-intern" />
        <h3 className="card-title-2">{title}</h3>
        <p className="card-details">Other details</p>
        <button
          className="apply-button"
          onClick={() =>
            window.open(
              "https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform",
              "_blank"
            )
          }
        >
          APPLY
        </button>
      </div>
    </div>
  );
};

export default InternCard;
